import { SearchParameter } from './review/search-parameter.model';

export class SearchReportExportRequest {
  searchReportId: string;
  filterString: string;
  parameter: SearchParameter;
}
